import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { createActivityfeedSyncActions } from './activityfeed.actions'
import { activityfeedInitialState } from './activityfeed.slice'
import type { ActivityfeedStore } from './activityfeed.type'

export const useActivityfeedStore = create<ActivityfeedStore>()(
  devtools(
    subscribeWithSelector(
      immer((set) => ({
        ...activityfeedInitialState,
        ...createActivityfeedSyncActions(set),
      }))
    ),
    {
      name: StoreDevtoolsName.Activityfeed,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
